import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import type { ResponseType } from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type TimesheetSidebarCounts = {
  draftNotSubmittedCount: number;
  pendingApprovalCount: number;
};

export function useTimesheetSidebarCountsQuery(enabled: boolean) {
  const pendingQuery = useQuery({
    queryKey: [QUERY_KEYS.timesheetSidebarCounts],
    queryFn: async () => {
      const res = await ApiRequest.get<ResponseType<TimesheetSidebarCounts>>(
        `${requestURLs.timesheet}sidebar-counts`
      );
      return res.data.data ?? { pendingApprovalCount: 0, draftNotSubmittedCount: 0 };
    },
    enabled,
    staleTime: 30_000,
  });

  const data: TimesheetSidebarCounts = useMemo(
    () => ({
      draftNotSubmittedCount: pendingQuery.data?.draftNotSubmittedCount ?? 0,
      pendingApprovalCount: pendingQuery.data?.pendingApprovalCount ?? 0,
    }),
    [pendingQuery.data]
  );

  return {
    data,
    isPending: pendingQuery.isPending,
    isError: pendingQuery.isError,
  };
}
